export default __webpack_public_path__ + "static/media/dhl-dsv-de.d986a14e.svg";